export default "__VITE_ASSET__CPRPfCKE__"